export const LOAD_HIGHT_LIGHT_EVENTS = '@EVENTS/LOAD_HIGHT_LIGHT_EVENTS';
export const LOAD_EVENTS = '@EVENTS/LOAD_EVENTS';
export const LOAD_ENDED_EVENTS = '@EVENTS/LOAD_ENDED_EVENTS';
export const LOAD_EVENT_DETAIL = '@EVENTS/LOAD_EVENT_DETAIL';
export const SAVE_USER_SELECT_TICKET = '@EVENTS/SAVE_USER_SELECT_TICKET';
export const CLEAR_USER_SELECT_TICKET = '@EVENTS/CLEAR_USER_SELECT_TICKET';
export const PRE_ORDER_PURCHASE = '@EVENTS/PRE_ORDER_PURCHASE';
export const SEARCH_EVENT = '@EVENTS/SEARCH_EVENT';
export const RESET = '@EVENTS/RESET';
